import { render } from "./LeadDialogData.vue?vue&type=template&id=2544ec9d"
import script from "./LeadDialogData.vue?vue&type=script&lang=js"
export * from "./LeadDialogData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__